import { Dispatch, RefObject, SetStateAction, useEffect, useRef } from "react";

export default function useModalHandler<T extends HTMLElement>(
  btnRef: RefObject<T> | null,
  setModalOpened: Dispatch<SetStateAction<boolean>>,
  skipClickOutside = false
) {
  const modalRef = useRef<T>(null);

  useEffect(() => {
    // this basically disable what this hook is doing
    if (skipClickOutside) return;

    const handleClick = (e: MouseEvent) => {
      if (!modalRef.current) return;

      const container = modalRef.current;

      // the btn click toggle will take care of this
      // skip this from this event
      const isBtn = btnRef && btnRef.current && (btnRef.current as any).contains(e.target);
      const isInside = container.contains(e.target as Node);

      if (!isInside && !isBtn) {
        setModalOpened(false);
      }
    };

    window.addEventListener("mouseup", handleClick);

    return () => window.removeEventListener("mouseup", handleClick);
  }, [modalRef, setModalOpened, btnRef, skipClickOutside]);

  return modalRef;
}
